// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: calc(100% - 20px);
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/experiments-widget/experiments-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;AACF","sourcesContent":[".content {\n  height: calc(100% - 20px);\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
